import { render, staticRenderFns } from "./TrackingWrapper.vue?vue&type=template&id=56766ee8&scoped=true&"
import script from "./TrackingWrapper.vue?vue&type=script&lang=js&"
export * from "./TrackingWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TrackingWrapper.vue?vue&type=style&index=0&id=56766ee8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56766ee8",
  null
  
)

export default component.exports